import PropTypes from 'prop-types'
import styled from 'styled-components'
import { background as backgroundColor, text as textColor } from 'theme/palette'

const SIZES = {
  sm: 25,
  md: 32,
  lg: 40,
  xl: 50,
}

const MIXINS = {
  dialog: {
    solid: true,
    size: 'lg',
  },
}

const StyledIconButton = styled.div.withConfig({
  shouldForwardProp: prop => ![
    'size',
    'square',
    'solid',
    'color',
    'depth',
    'depthHover',
    'variant',
    'variantSolidHover',
    'disabled',
    'clickDown',
    'depthActive',
    'mixin',
  ].includes(prop),
})`
  ${props => ({
    height: `${SIZES[props.size]}px`,
    width: `${SIZES[props.size]}px`,
    borderRadius: '50px',
    ...(props.square && {
      height: '44px',
      width: '44px',
      borderRadius: `${props.theme.globals.borderRadius.main}px`,
    }),
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    userSelect: 'none',
    cursor: 'pointer',
    ...(props.solid && {
      backgroundColor: props.theme.palette.background[props.variant].main,
    }),
    color: props.theme.palette.text[props.color],
    transition: props.theme.state.transition.main,
    boxShadow: props.depth
      ? props.theme.elevation[props.depth * 100]
      : 'none',
    ...(props.depthHover && { cursor: 'pointer' }),
    '&:hover': {
      ...(!props.disabled && {
        backgroundColor: props.theme.palette.background[props.variant].main,
        ...(props.depthHover && {
          boxShadow: props.theme.elevation[props.depthHover * 100],
        }),
        ...(props.solid && {
          backgroundColor: props.theme.palette.background[props.variantSolidHover].main,
          color: props.theme.palette.background[props.variantSolidHover].text,
        }),
      }),
    },
    '&:active': {
      ...(!props.disabled && {
        ...(props.clickDown && { transform: 'translateY(5px)' }),
        ...(typeof props.depthActive === 'number' && {
          boxShadow: props.theme.elevation[props.depthActive * 100],
        }),
      }),
    },
    ...(props.disabled && { opacity: props.theme.globals.opacity.disabled, cursor: 'default' }),
  })}
`

const IconButton = ({
  mixin,
  ...props
}) => (
  <StyledIconButton className="icon-button print-hide" {...props} />
)

IconButton.propTypes = {
  solid: PropTypes.bool,
  square: PropTypes.bool,
  color: PropTypes.oneOf(Object.keys(textColor)),
  variantSolidHover: PropTypes.oneOf(Object.keys(backgroundColor)),
  variant: PropTypes.oneOf(Object.keys(backgroundColor)),
  size: PropTypes.oneOf(Object.keys(SIZES)),
  depth: PropTypes.number,
  depthHover: PropTypes.number,
  depthActive: PropTypes.number,
  clickDown: PropTypes.bool,
  disabled: PropTypes.bool,
  mixin: PropTypes.oneOf(Object.keys(MIXINS)),
}

IconButton.defaultProps = {
  color: 'mainCool',
  variant: 'neutral_300',
  size: 'sm',
  variantSolidHover: 'neutralCool_700',
}

export default IconButton
